export enum UTMParams {
  UTM_ID = 'utm_id',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_MEDIUM = 'utm_medium',
  UTM_SOURCE = 'utm_source',
}

export const REGISTRATION_UTM_PARAMS = [ UTMParams.UTM_CAMPAIGN, UTMParams.UTM_ID, UTMParams.UTM_MEDIUM, UTMParams.UTM_SOURCE ];
